<template>
  <label class="toggle-switch">
    <input
      :checked="value"
      :disabled="disabled"
      type="checkbox"
      @change="$emit('input', $event.target.checked)"
    >
    <span class="slider" />
  </label>
</template>

<script>
/* eslint-disable vue/require-default-prop, vue/require-prop-types */
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.toggle-switch {
  position: relative;
  display: inline-block;
  width: 40px;
  min-width: 40px;
  max-width: 40px;
  height: 20px;

  input {
    opacity: 0;
    width: 0;
    height: 0;

    &:checked {
      + {
        .slider {
          background-color: #1A85E4;
          &::before {
            transform: translateX(19px);
          }
        }
      }
    }
    &:focus {
      + {
        .slider {
          box-shadow: 0 0 1px #1A85E4;
        }
      }
    }
  }
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: .4s;
    border-radius: 9999px;

    &::before {
      position: absolute;
      content: "";
      height: 16px;
      width: 16px;
      left: 2px;
      bottom: 2px;
      background-color: white;
      transition: .4s;
      border-radius: 50%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/inputs/jSwitch.vue